import { ApiError } from "../../shared/errors/ApiError";

export function unwrapProfileResponse(response) {
  if (response?.status === "success") {
    return {
      status: "success",
      ...(response.data || {}),
    };
  }

  if (response?.status === "error" && response.error) {
    throw new ApiError({
      error: response.error.code || "api_error",
      message: response.error.message || "Erro inesperado. Tente novamente mais tarde.",
      details: response.error.details,
    });
  }

  throw new ApiError({
    error: "invalid_profile_response",
    message: "Contrato de profile inválido.",
  });
}
